import { useContext } from "react";
import { ModalContext } from "./ModalContext";

export const useModal = () => {
  const { onClose, closeLabel } = useContext(ModalContext);

  return { onClose, closeLabel };
};
